import * as fromDatatype from '../datatype-library/index';

export interface bl_del_job_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  dochdr_link_guid: fromDatatype.GuidDataFieldInterface;
  docline_link_guid: fromDatatype.GuidDataFieldInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.GuidDataFieldInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_del_job_ext_RowClass 
  implements bl_del_job_ext_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    dochdr_link_guid: fromDatatype.GuidDataFieldInterface;
    docline_link_guid: fromDatatype.GuidDataFieldInterface;
    ext_type: fromDatatype.VarcharDatatypeInterface;
    ext_code: fromDatatype.VarcharDatatypeInterface;
    ext_option: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_string: fromDatatype.VarcharDatatypeInterface;
    value_file: fromDatatype.GuidDataFieldInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}
